import document from 'global/document';
import Enum from './enum';

let domLocale;

export const defaultLocale = 'en-us';

export const formats = new Enum('lower-lower', 'lower_UPPER');

export function getLocale(format = 'lower-lower') {
  if (!domLocale) {
    domLocale =
      document.documentElement && document.documentElement.lang
        ? document.documentElement.lang
        : defaultLocale;
  }

  const parts = domLocale.split('-');

  switch (format) {
    case formats.lower_UPPER:
      parts[1] = parts[1].toUpperCase();
      return parts.join('_');
    default:
      return domLocale;
  }
}

export function clearCache() {
  domLocale = null;
}
